import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CreateClient } from 'src/app/shared/interfaces/client.interface';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-create-client',
  templateUrl: './create-client.component.html',
  styleUrls: ['./create-client.component.scss'],
})
export class CreateClientComponent {
  createClientForm!: FormGroup;
  successMessage!: string;
  showSuccess!: boolean;
  errorMessage!: string;
  showError!: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.createClientForm = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
    });
  }

  createClient() {
    const createClient: CreateClient = {
      firstName: this.createClientForm.get('firstName')?.value,
      lastName: this.createClientForm.get('lastName')?.value,
    };
    // if (this.createClientForm.valid) {
    //   this.authService.createClient(createClient).subscribe({
    //     next: () => this.showSuccess = true,
    //     error: (err: HttpErrorResponse) => {
    //       this.showError = true;
    //       this.errorMessage = err.message;
    //     }
    //   })
    // } else {
    //   this.errorMessage = 'Fill all the required field!';
    // }
  }

  hasError(controlName: string, errorName: string) {
    return this.createClientForm.controls[controlName].hasError(errorName);
  }
}
